
export { defaultApiBasicX } from "/builds/dd3tech/wiggot/wiggot-web/packages/apis/new-apis/default-api.ts"